export const GLOSSARY_INDEX_LETTERS = [
	"A",
	"B",
	"C",
	"D",
	"E",
	"F",
	"G",
	"H",
	"I",
	"J",
	"K",
	"L",
	"M",
	"N",
	"O",
	"P",
	"Q",
	"R",
	"S",
	"T",
	"U",
	"V",
	"W",
	"X",
	"Y",
	"Z",
	"#",
] as const;

export type GlossaryIndexLetter = (typeof GLOSSARY_INDEX_LETTERS)[number];

/** First-letter bucket for A–Z glossary grouping (`#` for digits/symbols). */
export function glossaryIndexLetter(label: string): GlossaryIndexLetter {
	const trimmed = label.trim();
	if (trimmed.length === 0) {
		return "#";
	}
	const first = trimmed.charAt(0).toUpperCase();
	if (first >= "A" && first <= "Z") {
		return first as GlossaryIndexLetter;
	}
	return "#";
}

export function groupGlossaryItemsByLetter<T extends { label: string }>(
	items: T[]
): Map<GlossaryIndexLetter, T[]> {
	const groups = new Map<GlossaryIndexLetter, T[]>();
	for (const letter of GLOSSARY_INDEX_LETTERS) {
		groups.set(letter, []);
	}
	for (const item of items) {
		const letter = glossaryIndexLetter(item.label);
		groups.get(letter)?.push(item);
	}
	return groups;
}
